module.exports = __webpack_public_path__ + "img/cf.6943c721.svg";